(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.community').forEach((section) => {
      const track = section.querySelector('[data-community-track]');
      const prev = section.querySelector('[data-community-prev]');
      const next = section.querySelector('[data-community-next]');

      if (!track || !prev || !next) return;

      const amount = () => Math.round(track.clientWidth * 0.86);

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playful-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.playful-featured-collection').forEach((section) => {
      const track = section.querySelector('[data-carousel-track]');
      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');

      if (!track || !prev || !next) return;

      const scrollAmount = () => Math.round(track.clientWidth * 0.88);
      const resetToStart = () => {
        track.scrollLeft = 0;
      };

      resetToStart();

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      window.addEventListener('pageshow', resetToStart);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
